import {
    GESTION_OPERATIVA_UPDATE_BILLS_SUCCESS,
    GESTION_OPERATIVA_UPDATE_BILLS_FAILURE,
    GESTION_OPERATIVA_UPDATE_BILLS_DISMISS_ERROR,
    GESTION_OPERATIVA_UPDATE_BILLS_BEGIN
  } from '../constants'

export function reducer(state, action) {
    switch (action.type) {
      case GESTION_OPERATIVA_UPDATE_BILLS_SUCCESS:
        // The request is success
        // eslint-disable-next-line no-case-declarations
        const billings = state.sale.Bills.map(item => {
          if(item.id === state.sale.bill.id) {
            return { ...item, status: "EDITADA", updatedAt: new Date() }
          }
          return item
        })
  
        return {
          ...state,
          billsPending: false,
          billsError: null,
          billsAction: 'updated',
          sale: { ...state.sale, bill: action.data, Bills: [...billings, action.data] },
        }
  
      case GESTION_OPERATIVA_UPDATE_BILLS_FAILURE:
        // The request is failed
        return {
          ...state,
          billsError: action.data.error,
          billsPending: false,
          sale: { ...state.sale }
        }
  
      case GESTION_OPERATIVA_UPDATE_BILLS_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          billsError: null,
          billsAction: null,
          billsPending: false,
        }
      
      case GESTION_OPERATIVA_UPDATE_BILLS_BEGIN:
        // Loading
        return {
          ...state,
          billsPending: action.data,
          billsAction: null,
          billsError: null
        }
  
      default:
        return state
    }
  }
  